'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SidebarVisibilityContextType {
  sidebarVisible: boolean;
  setSidebarVisible: (visible: boolean) => void;
  sidebarExpanded: boolean;
  setSidebarExpanded: (expanded: boolean) => void;
}

const SidebarVisibilityContext = createContext<SidebarVisibilityContextType | undefined>(undefined);

export function SidebarVisibilityProvider({ children }: { children: ReactNode }) {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <SidebarVisibilityContext.Provider value={{ sidebarVisible, setSidebarVisible, sidebarExpanded, setSidebarExpanded }}>
      {children}
    </SidebarVisibilityContext.Provider>
  );
}

export function useSidebarVisibility() {
  const context = useContext(SidebarVisibilityContext);
  if (context === undefined) {
    throw new Error('useSidebarVisibility must be used within SidebarVisibilityProvider');
  }
  return context;
}
